import axios from "axios";
import { URL } from "./URL";

const API = axios.create({
	baseURL: URL.AXIOS_BASE_URL,
});

API.interceptors.response.use(
	(response) => {
		return response;
	},
	async function (error) {
		if (error.response.status === 401) {
			localStorage.clear();
			window.location = "/";
		}
		return Promise.reject(error);
	}
);

export default API;
